import { ReactElement } from 'react';

import { vpaSettingsConstants } from '../../_constants/settingsConstants';
import { VerticalSettingsForm } from '../layout/VerticalSettingsForm';

type Props = {
  memoryGrowthDetectionField: ReactElement;
};

export const MemoryGrowthDetectionSettingsContainer = ({
  memoryGrowthDetectionField,
}: Props) => {
  const { title, description, docsLinkKey } =
    vpaSettingsConstants.memoryGrowthDetection;

  return (
    <VerticalSettingsForm
      title={title}
      description={description}
      docsLinkKey={docsLinkKey}
    >
      {memoryGrowthDetectionField}
    </VerticalSettingsForm>
  );
};
